import { Injectable } from '@angular/core'
import { Router } from '@angular/router'

import { AssetClassModel } from '../../shared/asset-class-model'
import { FilterModel } from '../../shared/filter-model'
import { ProductTypeModel } from '../../shared/product-type-model'
import { ObservableService } from '../observable-service/observable.service'
import { FilterGroup } from './models/filter-group-enum'
import { FilterGroupStateWrapper } from './models/filter-group-state-wrapper'
import { FilterState } from './models/filter-state'
import { UnmodifiableFilterStateWrapper } from './models/unmodifiable-filter-state-wrapper'

@Injectable({
  providedIn: 'root',
})
export class FilterStateSyncupProcess {
  eventLatch: boolean
  constructor(
    private filterModel: FilterModel,
    private filterState: FilterState,
    private route: Router,
    private readonly observableService: ObservableService,
  ) {
    this.filterModel.telecastFilterBy.subscribe(
      (assetClassModel: AssetClassModel) => {
        this.filterState.setFiltersGroupState(
          new FilterGroupStateWrapper(
            assetClassModel.filterByLevel1,
            FilterGroup.AssetClasFilterGroup,
          ),
        )
        this.afterFilterStateUpdate()
      },
    )
    this.filterModel.telecastProductType.subscribe(
      (productTypeModel: ProductTypeModel) => {
        this.filterState.setFiltersGroupState(
          new FilterGroupStateWrapper(
            productTypeModel.productType,
            FilterGroup.ProductTypeFilterGroup,
          ),
        )
        this.afterFilterStateUpdate()
      },
    )

    this.observableService.viewTypeValue.subscribe((displayTypeName) => {
      this.filterState.setSelectedDisplayType(displayTypeName)
      this.afterFilterStateUpdate()
    })

    this.observableService.benchmarkSelectedValue.subscribe(
      (isSelectedBenchMark: boolean) => {
        this.filterState.setBenchMarkSelected(isSelectedBenchMark)
        this.afterFilterStateUpdate()
      },
    )

    this.observableService.sharedClassSelectedValue.subscribe(
      (isAllShareClassSelected: boolean) => {
        this.filterState.setAllShareClassSelected(isAllShareClassSelected)
        this.afterFilterStateUpdate()
      },
    )
  }
  afterFilterStateUpdate() {
    if (this.eventLatch) {
      const filterStateWrapper: UnmodifiableFilterStateWrapper =
        new UnmodifiableFilterStateWrapper()
      filterStateWrapper.setFilterState(this.filterState)
      this.observableService.changeConsolidateFiltersObservable(
        filterStateWrapper,
      )
      this.route.navigate([], {
        queryParams: filterStateWrapper.getFilterStateAsUrlParamObj(),
      })
    }
  }
}
